import Page from '~/components/Shared/Layout/Page/Page';
import Heading from '~/components/Shared/Heading/Heading';
import { ButtonLink } from '~/ui';
import { AnnouncementsBoard } from './AnnouncementsBoard/AnnouncementsBoard';
import { AnnouncementsPageInfo } from './AnnouncementsPageInfo/AnnouncementsPageInfo';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const Announcements = (): JSX.Element => {
  const { t } = useTranslation();
  const [statusFilter, setStatusFilter] = useState('');

  return (
    <Page
      heading={
        <Heading
          text={t('news')}
          actions={
            <ButtonLink text={t('create_news')} to="/announcements/create" />
          }
        />
      }
    >
      <AnnouncementsPageInfo statusFilter={statusFilter} setStatusFilter={setStatusFilter} />
      <AnnouncementsBoard statusFilter={statusFilter} />
    </Page>
  );
};

export default Announcements;
